<template>
  <li class="dialog-tree-row">
    <div v-show="!loading">
      <div
        v-if="!editing && $store.claims.phrases > 2"
        class="edit-icons"
      >
        <div class="icon-container">
          <i
            v-if="!isStart"
            class="material-icons right grey-text text-darken-1"
            @click="edit()"
          >edit</i>
        </div>
      </div>
      <div
        :id="'item_'+itemNumber"
        @click="toggle"
        :data-parent-open="parentOpen"
        :data-open="open"
        v-if="!editing"
        class="text-preview"
        v-bind:class="{'grey-text text-darken-1': isStart}"
      >
        <span v-if="!isStart && $store.inspectionViewMT"  class="number-badge">{{itemNumber}}</span>

        <i
          class="material-icons"
          v-bind:class="{'outline': open && !isStart, 'helen-green-text': !isStart}"
          :id="dialog.id + '_'+ itemNumber"
        >{{icon}}</i>
        <div class="preview-div">
          {{ primaryTranslation }}
          <div
            v-if="!isStart"
            dir="auto"
            class="secondary-language"
            :id="'secondary-translation-' + dialog.id"
          >{{ secondaryTranslation }}</div>
        </div>
      </div>
      <div v-if="editing" class="editingBox">
        <div class="toolbar">
          <i @click="edit()" class="material-icons prefix grey-text text-darken-1">undo</i>
          <i @click="save()" class="material-icons prefix grey-text text-darken-1">save</i>
        </div>
        <div class="input-field">
          <textarea
            type="text"
            v-model="editingPhraseText"
            :style="'height:'+setRows(dialog.id)+'rem'"
          ></textarea>
        </div>
        <div
          v-if="!isStart"
          dir="auto"
          class="secondary-language"
          :id="'secondary-translation-edit-' + dialog.id"
        >{{ secondaryTranslation }}</div>
      </div>
      <ul v-show="open" class="browser-default dialog-tree-list" v-bind:class="{start: isStart}">
        <MissingTranslationItem
          v-for="(id, index) in dialog.next"
          :key="index"
          :itemNumber="isStart ? (index+1).toString() : itemNumber+'.'+(index+1)"
          :parentOpen="open"
          :parentId="dialog.id"
          :mutatedParentId="dialog.id+'_'+itemNumber"
          :dialog="nextDialogs[id]"
          v-if="nextDialogs[id]"
        />
      </ul>
      <ul
        v-show="open && empty"
        class="browser-default dialog-tree-list"
        v-bind:class="{start: isStart}"
      >
        <li class="grey-text text-darken-1 text-preview">Empty</li>
      </ul>
    </div>
    <Spinner v-if="loading" :size="'tiny'" />
  </li>
</template>

<script>
import Spinner from "./Spinner";

export default {
  name: "MissingTranslationItem",
  props: {
    dialog: Object,
    parentId: String,
    mutatedParentId:String,
    parentOpen: Boolean,
    itemNumber: String,
  },
  components: {
    Spinner,
  },
  data() {
    return {
      open: true,
      phrase: {},
      nextDialogs: {},
      editing: false,
      editingPhraseText: "",
      loadingDialogs: true,
      loadingPhrase: true,
      initalized: false,
      initialId : null
    };
  },
  watch: {
    "$store.lastPhraseUpdated": function (p) {
      var ID = p.id;
      if (ID == this.phrase.id) {
        this.phrase = Object.assign({}, this.$store.lastPhraseUpdated);
        var idx = this.$store.dialogsMissingTranslation.indexOf(this.dialog.id.toString());
        if(idx >= 0){
          this.$store.dialogsMissingTranslation.splice(idx, 1);
          this.$store.dialogsMissingTranslationCount--;
          if(idx <= this.$store.currentIndexMT){
            this.$store.currentIndexMT--;
          }
        }
      }
    },
    parentOpen: function (isOpen) {
       this.open = isOpen;
        if (this.dialog.next && this.dialog.next.length> 0)
          this.getNext()
            .then(() => (this.loadingDialogs = false))
            .catch(() => (this.loadingDialogs = false));
        else {
          if(this.empty){
            this.open = false;
          }
        }
        this.initialized = true;
     // }
    },
    "empty": function(isEmpty){
      if(isEmpty){
        this.open = false
      }
    },
    "dialog.phrase": function (id) {
      this.getPhraseByID(id);
    },
    "dialog.next": function (list) {
      this.nextDialogs = Object.keys(this.nextDialogs)
        .filter((d) => {
          return (
            this.dialog.next.indexOf(this.nextDialogs[d].id) > -1 ||
            this.nextDialogs[d].new
          );
        })
        .reduce((obj, key) => {
          obj[key] = this.nextDialogs[key];
          return obj;
        }, {});
      var newDialogs = [];
      if (this.dialog.next)
        this.dialog.next.forEach((id) => {
          if (!this.nextDialogs[id]) {
            newDialogs.push(id);
          }
        });
      newDialogs.forEach((element) => {
        this.getDialogByID(element);
      });
    }
  },
  methods: {
    setRows(id) {
      var target = document.getElementById("secondary-translation-" + id)
        ? document.getElementById("secondary-translation-" + id)
        : document.getElementById("secondary-translation-edit-" + id);
      if (!target) return 8;
      var style = window.getComputedStyle(target, null);
      var height = parseInt(style.getPropertyValue("height"));
      var font_size = parseInt(style.getPropertyValue("font-size"));
      var line_height = parseInt(style.getPropertyValue("line-height"));
      var box_sizing = style.getPropertyValue("box-sizing");

      if (isNaN(line_height)) line_height = font_size * 1.2;

      if (box_sizing == "border-box") {
        var padding_top = parseInt(style.getPropertyValue("padding-top"));
        var padding_bottom = parseInt(style.getPropertyValue("padding-bottom"));
        var border_top = parseInt(style.getPropertyValue("border-top-width"));
        var border_bottom = parseInt(
          style.getPropertyValue("border-bottom-width")
        );
        height =
          height - padding_top - padding_bottom - border_top - border_bottom;
      }
      var lines = Math.ceil(height / line_height);
      lines = 2 * lines;
      return lines < 5 ? 4 * lines : 2 * lines;
    },
    /**
     * Toggle folder state
     */
    toggle() {
      this.open = !this.open || this.isStart;
    },
    /**
     * Fetch dialog based on ID
     * @param {string} id ID of dialog to fetch
     */
    getDialogByID(id) {
      return new Promise((resolve, reject) => {
        var dialog = Object.assign({}, this.$store.dialogsMT[id]);
        var dID = this.$store.dialogCounter++;
        if (!dialog.next) dialog.next = [];
        dialog.next = dialog.order || [];
        this.$store.loadCount += dialog.next.length;
        this.$set(this.nextDialogs, id, dialog);
        resolve();
      });
    },
    /**
     * Fetch phrase based on ID
     * @param {number} id ID of pharse to fetch
     */
    getPhraseByID(id) {
      return new Promise((resolve, reject) => {
        if (!id) {
          resolve();
          return;
        }
        this.$store.loadCount -= 1;
        this.phrase = this.$store.phrasesMT[id];
        this.$store.checkTranslationPhrases[this.dialog.id] = this.phrase;
        resolve();
      });
    },
    /**
     * Toggle editing state
     */
    edit() {
      this.editing = !this.editing;
      if (this.editing) {
        this.editingPhraseText = this.primaryEditingTranslation;
      }else{
        this.$store.moveToItem(this.itemNumber);
      }
    },
    /**
     * Call for saving changes to current dialog
     */
    save() {
      if (this.editingPhraseText.length < 1) {
        this.toast("You can't add an empty phrase");
        return;
      }
      var translationExist =
        this.phrase.translations.filter(
          (t) => t.language == this.$store.preferredLanguage
        ).length > 0;
      if (translationExist) {
        this.phrase.translations.forEach((t) => {
          if (t.language == this.$store.preferredLanguage) {
            t.text = this.editingPhraseText;
          }
        });
      } else {
        var translation = {
          text: this.editingPhraseText,
          language: this.$store.preferredLanguage,
        };
        this.phrase.translations.push(translation);
      }
      this.$http.put("phrases/" + this.phrase.id, this.phrase).then((r) => {
        this.$store.lastPhraseUpdated = this.phrase;
        const index = this.$store.itemNumberArray.findIndex((i)=> i === this.itemNumber);
        if(!translationExist){
          this.$store.addtranslatedphrase(this.phrase.id);

        }
        if(index!==-1){
          const nextItemNumber = this.$store.itemNumberArray[index+1];
          this.$store.findIncompleteDialogs();
          this.$store.moveToItem(nextItemNumber);
        }
        this.editing = false;
        this.$store.saveChangesMT = true;
      });
    },
    /**
     * Retireves the next dialogs
     */
    getNext() {
      return new Promise((resolve, reject) => {
        var a = this.dialog.next.map((id) => {
          return this.getDialogByID(id);
        });
        Promise.all(a).then(() => resolve());
      });
    },
    toast(text) {
      M.toast({
        html: text,
      });
    },
  },
  mounted() {
    this.initialId = this.dialog.id;
    this.$store.setItemNumber(this.dialog.id, this.itemNumber,this.mutatedParentId);
  },
  /**
   * 
   * Intitialize the component
   */
  created() {
    if (this.isStart) this.open = true;
    if (this.dialog.new) this.edit();
    this.getPhraseByID(this.dialog.phrase)
      .then(() => (this.loadingPhrase = false))
      .catch(() => (this.loadingPhrase = false));
    if (this.parentOpen) {
      if (this.dialog.next && this.dialog.next.length)
        this.getNext()
          .then(() => {
            this.loadingDialogs = false;
            this.initialized = true;
          })
          .catch(() => {
            this.loadingDialogs = false;
            this.toast("Could not fetch the next set of dialogs");
          });
      else {
        this.loadingDialogs = false;
        this.initialized = true;
        this.toggle();
      }
    }
  },
  computed: {
    secondaryTranslation() {
      if (this.isStart) return "";

      if (this.$store.secondaryLanguageMT === "")
        return "No secondary language is selected";

      if (this.phrase.translations)
        var foundTranslation = this.phrase.translations.filter(
          (t) => t.language === this.$store.secondaryLanguageMT
        )[0];
      if (foundTranslation) return foundTranslation.text;
      return foundTranslation
        ? foundTranslation.text
        : "Phrase has no translation for the secondary language";
    },
    /**
     * Get translation based on current preferred language
     */
    primaryTranslation() {
      if (this.isStart) return this.$store.instanceMT;
      if (this.phrase.translations)
        var foundTranslation = this.phrase.translations.filter(
          (t) => t.language === this.$store.preferredLanguage
        )[0];
      if (foundTranslation) return foundTranslation.text;
      return foundTranslation
        ? foundTranslation.text
        : "Phrase has no translation for this language";
    },

    /**
     * Get translation based on current preferred language (if none found => '')
     */
    primaryEditingTranslation() {
      if (this.phrase.translations)
        var foundTranslation = this.phrase.translations.filter(
          (t) => t.language === this.$store.preferredLanguage
        )[0];
      return foundTranslation ? foundTranslation.text : "";
    },
    /**
     * Get icon based on dialog's type
     */
    icon() {
      const types = {
        answer: "chat",
        instruction: "feedback",
        question: "help",
        category: "folder",
        start: "view_list",
        default: "error",
        instruction_paragraph: "linear_scale"
      };
      return (
        types[this.dialog.type] || types[this.isStart ? "start" : "default"]
      );
    },
    /**
     * Returns last editor of dialog
     */
    editor() {
      const modifier = this.$store.users.filter(
        (u) => u.id === this.dialog.editor
      )[0];
      return modifier ? modifier.username : "";
    },
    creationInfo() {
      const creator = this.$store.users.filter(
        (u) => u.id === this.dialog.creator
      )[0];
      return creator && this.dialog.created
        ? "Created by " +
            creator.username +
            " ( " +
            this.dialog.created.split("T")[0] +
            " " +
            this.dialog.created.split("T")[1].slice(0, 5) +
            " )"
        : "";
    },
    /**
     * Get empty state of nextDialogs
     */
    empty() {
      for (var key in this.nextDialogs) {
        if (this.nextDialogs.hasOwnProperty(key)) return false;
      }
      return true;
    },
    /**
     * Returns if dialog is start-dialog
     */
    isStart() {
      return this.dialog.tags && this.dialog.tags.indexOf("start") > -1;
    },
    /**
     * Returns if the dialog is loading
     */
    loading() {
      return this.loadingPhrase || this.loadingDialogs;
    },
  },
};
</script>

<style scoped>
.start {
  padding-left: 0em;
}

ul.start > li > div > ul li {
  border-top: 1px solid #ccc;
  margin-bottom: -1px;
}
ul.start > li > div > ul li:hover {
  border-left: 2px solid dimgray;
  padding-left: 2px;
}
ul.start > li {
  padding: 5px;
  padding-right: 0px;
}
ul.start > li:nth-child(2n + 1) {
  background: #efefef;
  border-left: 2px solid #b7b7b7;
}
ul.start > li:nth-child(2n) {
  border-left: 2px solid #fff;
}

.center {
  position: relative;
  margin-left: -50%;
  left: -50%;
}

.answer-types > label {
  margin-right: 1em;
}

.answer-types > p {
  color: darkgray;
}

.icon-spacer {
  width: 24px;
  height: 24px;
  margin-left: 15px;
}

.dialog-tree-list {
  list-style-type: none;
}

.text-preview {
  white-space: nowrap;
  padding-top: 0.4em;
  padding-bottom: 0.4em;
  padding-right: 72px;
}

.dialog-tree-row {
  cursor: pointer;
  padding-left: 0;
}

.material-icons {
  display: inline-flex;
  vertical-align: top;
  user-select: none;
}

.editingBox {
  border: 1px solid lightgray;
  padding: 0em 1em 0em 1em;
  margin-right: 1px;
  background: #fff;
}

.edit-icons {
  position: relative;
}
.icon-container {
  position: absolute;
  right: 0;
  top: 0.4em;
}
.toolbar {
  text-align: right;
  margin: 0em -1em 0em -1em;
  padding: 0.5em 1em 0.5em 1em;
  border-bottom: 1px solid lightgray;
}

.toolbar > i {
  margin-left: 0.5em;
}

.toolbar > i:hover {
  color: #6eb2bd !important;
}

.toolbar > .left {
  margin-left: 0;
}

.toolbar > .left:hover {
  color: #e57373 !important;
}
.number-badge {
  font-weight: 300;
  color: #fff;
  background-color: grey;
  border-radius: 2px;
  padding: 0 6px;
  vertical-align: top;
}
.preview-div {
  display: inline-block;
  white-space: normal;
  padding-right: 72px;
}
.instruction-image-wrapper {
  max-height: 212px;
  overflow-x: auto;
  background: white;
  display: flex;
  overflow-y: hidden;
}
.bg-highlight {
  background: #fff59d !important;
}
.highlight {
  background: #fffbce !important;
}
.secondary-language {
  font-size: 12px;
  color: #888;
}
</style>